import React, { useState, useEffect } from "react";
import validator from "validator";

function CartInputField(props) {
  const [ErrorMsg, setErrorMsg] = useState(() => {
    const initialState = initErrorMsg();
    return initialState;
  });

  function initErrorMsg() {
    if (props.type === "radio") return "";
    if (!props.errList || props.errList.length === 0) return "";
    let txt = "";
    let errList = props.errList.filter((el) => el.id === props.name);
    if (errList.length > 0) {
      errList.forEach((el) => (txt += el.msg + " "));
    }
    const initialState = txt;
    return initialState;
  }

  useEffect(() => {
    if (ErrorMsg === "") {
      let txt = initErrorMsg();
      if (txt !== "") setErrorMsg(txt);
    }
  }, [props.errList]);

  function checkField(ev) {
    //console.log(props);
    if (props.type === "checkbox") {
      props.change(ev.target.checked);
      setErrorMsg("");
    } else {
      props.change(ev.target.value);
      let val = ev.target.value;
      if (props.type === "phone" && val.length > 0) {
        if (!val.match(/^[0-9\s(\-+)]*$/)) {
          setErrorMsg("Inserire un numero di telefono valido.");
          return;
        } else {
          if (val.length < 8) {
            setErrorMsg("Numero troppo corto.");
            return;
          }
        }
      }
      if (props.type === "email" && val.length > 0) {
        if (!validator.isEmail(val)) {
          setErrorMsg("Inserire un indirizzo di email valido.");
          return;
        }
      }
      if (props.type === "cap" && val.length > 0) {
        if (!validator.isPostalCode(val, "IT")) {
          setErrorMsg("Inserire un CAP valido.");
          return;
        }
      }
      if (props.type === "password" && val.length > 0) {
        if (props.name === "Password") {
          if (
            !validator.isStrongPassword(val, {
              minLength: 8,
              minLowercase: 1,
              minUppercase: 1,
              minNumbers: 1,
              minSymbols: 0,
            })
          ) {
            setErrorMsg(
              "La password inserita è troppo debole (inserire almeno una maiuscola, una minuscola, un numero. Lunghezza minima 8 caratteri)."
            );
            return;
          }
        }
      }
      if (props.required && val.trim().length === 0) {
        setErrorMsg("Si prega di non lasciare il campo vuoto.");
      } else {
        setErrorMsg("");
      }
    }
  }

  const startingStyle = {
    border: "1px solid #B3B3B3",
  };
  const validStyle = {
    border: "1px solid green",
  };
  const invalidStyle = {
    border: "1px solid red",
  };
  function setStyle() {
    if (!props.required) return startingStyle;
    if (props.value.length === 0 && ErrorMsg.length === 0) return startingStyle;
    if (ErrorMsg.length === 0) return validStyle;
    else return invalidStyle;
  }

  function labelUrl(label, urlText, url) {
    let txt =
      label + " (<a target='_blank' href='" + url + "'>" + urlText + "</a>)";
    return { __html: txt };
  }

  function composeLabel(labelTxt) {
    if (props.url && props.url.length > 0) {
      return (
        <label
          dangerouslySetInnerHTML={labelUrl(labelTxt, props.urlText, props.url)}
        />
      );
    } else return <label>{labelTxt}</label>;
  }

  let label = props.lbl;
  if (props.required === true && label.length > 0) label += " *";

  return (
    <div className={props.cssClass}>
      {props.labelRight === true ? null : composeLabel(label)}

      {props.type === "radio" ? (
        <input
          type={props.type}
          name={props.name}
          value={props.value}
          onChange={(e) => checkField(e)}
          checked={props.curVal === props.value}
        />
      ) : props.type === "checkbox" ? (
        <input
          type={props.type}
          name={props.name}
          value={props.value}
          onChange={(e) => checkField(e)}
          checked={props.value}
          style={setStyle()}
        />
      ) : props.type === "password" ? (
        <input
          type={props.type}
          name={props.name}
          value={props.value}
          onChange={(e) => checkField(e)}
          style={setStyle()}
          readOnly={props.readonly && props.readonly === true ? true : false}
          autoComplete={props.autoComplete}
        />
      ) : (
        <input
          type={props.type}
          name={props.name}
          value={props.value}
          placeholder={props.placeholder ? props.placeholder : ""}
          onChange={(e) => checkField(e)}
          style={setStyle()}
          readOnly={props.readonly && props.readonly === true ? true : false}
        />
      )}

      {props.labelRight === true ? composeLabel(label) : null}
      {props.imgUrl && props.imgUrl.length > 0 ? (
        <img src={props.imgUrl} alt={props.imgAlt} title={props.imgAlt} />
      ) : null}

      {props.labelRight === true ? <div className="clear" /> : null}

      {ErrorMsg.length > 0 ? (
        <div
          className={
            props.labelRight === true ? "errore_cart" : "campo_vuoto_cart"
          }
        >
          <p>{ErrorMsg}</p>
        </div>
      ) : null}
    </div>
  );
}

export default CartInputField;
